import React from 'react';
import './RunsPanel.css';

interface RunsPanelProps {
  actionRuns: any[];
  documents: any[];
}

const formatTime = (ts?: number) => {
  if (!ts) return '—';
  const d = new Date(ts);
  return d.toLocaleString();
};

const RunsPanel: React.FC<RunsPanelProps> = ({ actionRuns = [], documents = [] }) => {
  return (
    <div className="runs-panel">
      <div className="runs-section">
        <div className="runs-header">
          <h2>Run History</h2>
          <p className="runs-subtitle">Resumable run log (ops_action_runs)</p>
        </div>
        <div className="runs-table">
          <div className="runs-row runs-head">
            <div>Run Type</div>
            <div>Started</div>
            <div>Completed</div>
            <div>Errors</div>
          </div>
          {actionRuns.map((run: any) => (
            <div key={run._id} className="runs-row">
              <div className="runs-type">{run.runType || '—'}</div>
              <div>{formatTime(run.startedAt)}</div>
              <div>{formatTime(run.completedAt)}</div>
              <div className={run.errors?.length ? 'runs-error' : 'runs-ok'}>
                {run.errors?.length || 0}
              </div>
            </div>
          ))}
          {actionRuns.length === 0 && (
            <div className="runs-empty">No run history yet.</div>
          )}
        </div>
      </div>

      <div className="runs-section">
        <div className="runs-header">
          <h2>Evidence & Documents</h2>
          <p className="runs-subtitle">Latest artifacts (documents)</p>
        </div>
        <div className="evidence-list">
          {documents.map((doc: any) => (
            <div key={doc._id} className="evidence-card">
              <div className="evidence-title">{doc.title}</div>
              <div className="evidence-meta">{doc.type} • {formatTime(doc._creationTime)}</div>
              <div className="evidence-content">{doc.content?.slice(0, 240) || ''}{doc.content?.length > 240 ? '…' : ''}</div>
            </div>
          ))}
          {documents.length === 0 && (
            <div className="runs-empty">No documents yet.</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RunsPanel;
